import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//Components
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Button } from 'devextreme-react';

import {
    FormControlLabel,
    Checkbox,
    TextField
} from '@material-ui/core';

import NumberFormat from 'react-number-format';

import FormFieldDataScadenza from './form/FormFieldDataScadenza';

import ActionProgress from './../shared/ActionProgress';

//utils
import { parseJSON } from 'date-fns';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
    label: {
        marginLeft: '0px'
    },
    greyedLabel: {
        marginLeft: '0px',
        color: 'rgba(0, 0, 0, 0.3)'
    },
});



const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

function formatLength(value, maxLength) {
    let format = value.substring(0, maxLength);

    return format;
}

//Solo numeri sulla TextField
function NumberFormatCustom(props) {
    const { inputRef, onChange, maxLength, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            allowNegative={false}
            allowLeadingZeros
            format={(value) => formatLength(value, maxLength)}
        />
    );
}

class EstendiLicenzaCmp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            estendiMesi: false,
        };

        this.submitState = this.submitState.bind(this);
        this.setEstendiMesi = this.setEstendiMesi.bind(this);
        this.handleScadenza = this.handleScadenza.bind(this);
        this.changeAndValidateField = this.changeAndValidateField.bind(this);


        this.clearAll = this.clearAll.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    componentDidUpdate(propsPrecedenti) {
        const { selected_license, initializeFields } = this.props;

        //solo se è aperto il dialog inizializzo i dati
        if (this.props.isOpen && this.props.isOpen !== propsPrecedenti.isOpen) {
            if (selected_license.DataScadenza !== null)
                initializeFields(parseJSON(selected_license.DataScadenza));
            else initializeFields(null);
        }
    }

    setEstendiMesi(e) {
        if (this.props.hasScadenza === true) {
            this.setState({ estendiMesi: e });

            if (e === false) this.props.handleChangeField('num_mesi', 0);
        }
        else this.setState({ estendiMesi: false });
    }

    handleScadenza(newValue) {

        this.changeAndValidateField('hasScadenza', newValue);

        if (newValue === false) {
            this.props.handleChangeField('num_mesi', 0);
            this.setState({ estendiMesi: false });
        }
    }

    changeAndValidateField(field, newValue) {
        this.props.handleChangeField(field, newValue);
        this.props.validateField(field);
    }

    // chiudo dialog EstendiLicenza e resetto valori store
    closeDialog() {
        this.props.showEditDataScadDialog();
        this.props.resetEditDataScad();
    }

    // dopo aver completato la modifica, faccio reset e refresh della griglia licenze e resetto campi del reducer
    clearAll() {
        //invio email con i dettagli della licenza creata
        this.props.sendLicenseDetails(this.props.selected_license.ProductKey, null);

        this.props.refreshLicenses(this.props.codiceUtente);
        this.props.resetFilters();
        this.props.resetEditDataScad();
    }

    submitState() {
        const { selected_license, new_data_scadenza, codiceUtente, editDataScad, showEditDataScadDialog } = this.props;

        showEditDataScadDialog();

        editDataScad(selected_license.ProductKey, new_data_scadenza, codiceUtente);
    }


    render() {
        const { classes, selected_license, new_data_scadenza, hasScadenza, num_mesi, errorText,
            isOpen, editDataScad, codiceUtente, isChanged, isValid,
            editDataScadRequestStatus, editDataScadErrorMessage } = this.props;

        return (
            <Fragment>
                <Dialog
                    onClose={this.closeDialog}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.closeDialog}>
                        Estendi Scadenza
                    </DialogTitle>
                    <DialogContent dividers>


                        <FormControlLabel className={this.state.estendiMesi === false ? classes.greyedLabel : classes.label}
                            control={
                                <Checkbox
                                    checked={this.state.estendiMesi}
                                    onChange={e => this.setEstendiMesi(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Estendi durata (mesi)"
                        />
                        <TextField
                            type="number"
                            value={num_mesi}
                            variant="outlined"
                            size="small"
                            label="Mesi"
                            disabled={!this.state.estendiMesi}
                            onChange={e => this.changeAndValidateField('num_mesi', e.target.value)}
                            InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 2 } }}
                            InputLabelProps={{ shrink: true }}
                        />


                        <FormFieldDataScadenza
                            value={new_data_scadenza}
                            hasScadenza={hasScadenza}
                            setScadenza={e => this.handleScadenza(e)}
                            helperText={errorText}

                            onDataScadenzaChange={e => this.changeAndValidateField('new_data_scadenza', e)}
                        />
                    </DialogContent>
                    <DialogActions className={classes.alignCenter}>
                        <Button
                            width={120}
                            text="Annulla"
                            type="normal"
                            stylingMode="outlined"
                            onClick={() => this.closeDialog()}
                        />
                        <Button
                            width={120}
                            text="Salva"
                            type="default"
                            disabled={(isChanged && isValid) ? false : true}
                            stylingMode="contained"
                            onClick={() => this.submitState()}
                        />
                    </DialogActions>
                </Dialog>

                <ActionProgress
                    status={editDataScadRequestStatus}
                    errorMessage={editDataScadErrorMessage}
                    tryAgainAction={() => editDataScad(selected_license.ProductKey, new_data_scadenza, codiceUtente)}
                    afterResolvedAction={() => this.clearAll()}
                />
            </ Fragment>
        );

    }
}

EstendiLicenzaCmp.propTypes = {
    editDataScad: PropTypes.func.isRequired,
    editDataScadRequestStatus: PropTypes.string.isRequired,
    editDataScadErrorMessage: PropTypes.string,
    new_data_scadenza: PropTypes.any,
    hasScadenza: PropTypes.bool.isRequired,
    num_mesi: PropTypes.any.isRequired,

    isChanged: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,


    validateField: PropTypes.func.isRequired,

    selected_license: PropTypes.shape({}),


    resetEditDataScad: PropTypes.func.isRequired,
    showEditDataScadDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(EstendiLicenzaCmp);